import { configureStore, combineReducers, AnyAction } from '@reduxjs/toolkit';
import { createWrapper, HYDRATE } from 'next-redux-wrapper';
import { Action } from 'redux';

import settingReducer from './setting/reducers';
import streamitReducer from './streamit/reducers';
import streamitShop from './shop/reducers';
import streamitMedia from './media/reducers';

// Create a combined reducer with hydration support
const combinedReducer = combineReducers({
  setting: settingReducer,
  streamit: streamitReducer,
  shop: streamitShop,
  media: streamitMedia
});

// Define the state types
export type AppState = ReturnType<typeof combinedReducer>;

// Root reducer with hydration handling
const rootReducer = (state: AppState | undefined, action: AnyAction) => {
  if (action.type === HYDRATE) {
    // Handle hydration with proper state merging
    return {
      ...state,
      ...action.payload,
    };
  }
  return combinedReducer(state, action);
};

// Configure the store with the root reducer
const makeStore = () =>
  configureStore({
    reducer: rootReducer,
    // Avoid serializability check errors during SSR
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }),
    devTools: process.env.NODE_ENV !== 'production',
  });

// Create the wrapper with the store
export const wrapperStore = createWrapper(makeStore, { debug: process.env.NODE_ENV !== 'production' });
